module.exports = "/hub/_next/static/assets/c6e4b06010f6929209e32639dde111fd.png";